import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { MenuService } from '../finance-payout/menu-service';
import { Subscription } from 'rxjs';
import { MenuHomeEnum } from 'app/home';
import { PayoutTransactionStatusEnum } from 'app/models/transaction/payout-transaction-status.enum';
import { Utils } from 'app/utils';
import * as moment from 'moment/moment';
import { ConfigService, XpressPaymentTransactionService, AppDataService } from 'app/services';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import { FieldTypeEnum, UserWalletOperationTypeModel } from 'app/models';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'finance-xendit',
    templateUrl: './finance-xendit.component.html',
    styleUrls: ['./finance-xendit.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class FinanceXenditComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    public onboardingTabMenu: Array<any> = [];

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    payoutTransactions: Array<any> = [];
    cols: any[] = [
        {
            field: 'Id',
            header: 'TX ID',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'id',
            placeholder: 'Type here',
            active: false,
            action: (rowData: any) => this.handleShowTransactionInfo(rowData)
        },
        {
            field: 'DisplayFormatCreatedAt',
            header: 'Transaction Date',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'DisplayFormatCreatedAt',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'DriverName',
            header: 'Driver Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'driverName',
            placeholder: 'Type here',
            active: false,
            action: (rowData: any) => this.handleShowDriverInfo(rowData)
        },
        {
            field: 'CustomerName',
            header: 'User Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'customerName',
            placeholder: 'Type here',
            active: false,
            action: (rowData: any) => this.handleShowCustomerInfo(rowData)
        },
        {
            field: 'TransactionType',
            header: 'Transaction Type',
            width: '10%',
            fieldType: FieldTypeEnum.Dropdown,
            model: 'transactionType',
            placeholder: 'Please Select',
            active: false,
            options: UserWalletOperationTypeModel.UserWalletOperationTypeList
        },
        {
            field: 'AmountText',
            header: 'Amount',
            width: '20%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'amountText',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'MerchantName',
            header: 'Merchant Name',
            width: '20%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'merchantName',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'XenditFee',
            header: 'Merchant Service Charge',
            width: '20%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'xenditFee',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'XenditVat',
            header: 'VAT of MSC (12%)',
            width: '20%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'xenditVat',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'Debit',
            header: 'Debit',
            width: '20%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'debitAmount',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'Credit',
            header: 'Credit',
            width: '20%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'creditAmount',
            placeholder: 'Type here'
        },
        {
            field: 'XenditBalance',
            header: 'Receiveable Wallet (Main Wallet)',
            width: '20%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'xenditBalance',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'XpayCustomer',
            header: 'Xpay Customer',
            width: '20%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'xpayCustomerAmount',
            placeholder: 'Type here',
            active: false,
        },
        {
            field: 'XpressWallet',
            header: 'Xpress Wallet (Driver)',
            width: '20%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'xpressWalletAmount',
            placeholder: 'Type here',
            active: false,
        }
    ];
    public defaultCols = this.cols.map(x => x);

    rowsPerPage: number = 13;
    totalRecords: number = -1;
    fieldTypeEnum = FieldTypeEnum;
    paginator: Paginator = new Paginator();
    visibleTransactionsFilter: boolean = false;
    visibleDriverDetail: boolean = false;
    transactionRiderId: number = 0;
    visibleCustomerDetail: boolean = false;
    visibleTransactionDetail: boolean = false;
    transactionCustomerId: number = 0;
    transactionId: number = 0;
    filterObj: any = {
        startDate: null,
        endDate: null,
        digitType: null,
        payService: null
    };
    txnHeaderSearch: any = {
        id: null,
        DisplayFormatCreatedAt: null,
        createdAt: null,
        riderId: null,
        customerName: null,
        driverName: null,
        userId: null,
        transactionType: null,
        amount: null,
        amountText: null,
        xenditFeeAmount: null,
        xenditFee: null,
        xenditVatAmount: null,
        xenditVat: null,
        debitAmount: null,
        debit: null,
        creditAmount: null,
        credit: null,
        xenditBalanceAmount: null,
        xenditBalance: null,
        xpayCustomerAmount: null,
        xpayCustomer: null,
        xpressWalletAmount: null,
        xpressWallet: null,
        merchantName: null,
    };
    first: number = 0;
    sortField: string | string[] = 'Id';
    sortOrder: number = -1;
    loading: boolean = false;
    searchTimer: number = 0;
    showDetailTransactionSidebar: boolean = false;
    selectedTransaction: any;
    arrayFilterStatuses: any =
        [
            {
                name: 'All', value: null
            },
            {
                name: 'Pending', value: PayoutTransactionStatusEnum.Pending
            },
            {
                name: 'Processing', value: PayoutTransactionStatusEnum.Processing
            },
            {
                name: 'Completed', value: PayoutTransactionStatusEnum.Completed
            }
        ];
    menuHomeEnumActive: MenuHomeEnum | undefined;
    $subscription: Subscription | undefined;

    tableName: string = EditTableConfig.FINANCE_XENDIT;
    exportHeaderColumns: string[] = [];
    exportDataColumns: string[] = [];

    public breadcrumbs: MenuItem[] = [{ icon: 'icon_finance' }, { label: 'Finances' }, { label: 'Accounting' }, { label: 'Xendit Transactions' }];

    constructor(
        private messageService: MessageService,
        private paymentTransactionService: XpressPaymentTransactionService,
        public configService: ConfigService,
        private menuService: MenuService,
        private cdRef: ChangeDetectorRef,
        public appDataService: AppDataService) {
            this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngOnInit(): void {
        this.$subscription = this.menuService.menuHomeEnumActive$.subscribe(
            (value) => {
                this.menuHomeEnumActive = value;
            }
        );
    }

    ngOnDestroy(): void {
        this.$subscription?.unsubscribe();
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.cols = event;
        }
        else {
            this.cols = this.defaultCols;
        }

        this.exportHeaderColumns = this.cols.map(x => x.header);
        this.exportDataColumns = this.cols.map(x => x.field);
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;
        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.callGridTitles(skip);
    }

    filter: {
        searchName: string;
    } = { searchName: '' };

    handleFilterChange(model: string, event: any): void {
        console.warn(model);
        console.warn(event);
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'Id') {
                this.txnHeaderSearch.id = event.target.value;
            }
            // if (model === 'AmountText') {
            //     this.txnHeaderSearch.id = event.target.value;
            // }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleShowTransactionInfo(value: any) {
        this.transactionId = value.Id;
        this.visibleTransactionDetail = true;
    }

    handleShowCustomerInfo(value: any) {
        this.transactionCustomerId = value.UserId;
        this.visibleCustomerDetail = true;
    }

    handleShowDriverInfo(value: any) {
        this.transactionRiderId = value.RiderId;
        this.visibleDriverDetail = true;
    }

    changedVisibleDriverDetailEmit(value: any) {
        this.visibleDriverDetail = value;
    }

    updateEventEmit(value: any) {
        this.visibleTransactionDetail = false;
    }

    changedVisibleCustomerDetailEmit(value: any) {
        this.visibleCustomerDetail = value;
    }

    getInOutTransactions(skip: number) {
        const dto = {
            SearchName: this.filter.searchName,
            Id: this.txnHeaderSearch.id ? this.txnHeaderSearch.id : null,
            CreatedAt: this.txnHeaderSearch.createdAt ? moment(this.txnHeaderSearch.createdAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            DisplayFormatCreatedAt: this.txnHeaderSearch.DisplayFormatCreatedAt ? this.txnHeaderSearch.DisplayFormatCreatedAt : null,
            DriverName: this.txnHeaderSearch.driverName ? this.txnHeaderSearch.driverName : null,
            CustomerName: this.txnHeaderSearch.customerName ? this.txnHeaderSearch.customerName : null,
            TransactionType: this.txnHeaderSearch.transactionType ? this.txnHeaderSearch.transactionType : null,
            Amount: this.txnHeaderSearch.amount ? this.txnHeaderSearch.amount : null,
            AmountText: this.txnHeaderSearch.amountText ? this.txnHeaderSearch.amountText : null,
            MerchantName: this.txnHeaderSearch.merchantName ? this.txnHeaderSearch.merchantName : null,
            XpayCustomerAmount: this.txnHeaderSearch.xpayCustomerAmount ? this.txnHeaderSearch.xpayCustomerAmount : null,
            XpayCustomer: this.txnHeaderSearch.xpayCustomer ? this.txnHeaderSearch.xpayCustomer : null,
            XpressWalletAmount: this.txnHeaderSearch.xpressWalletAmount ? this.txnHeaderSearch.xpressWalletAmount : null,
            XpressWallet: this.txnHeaderSearch.xpressWallet ? this.txnHeaderSearch.xpressWallet : null,
            XenditBalanceAmount: this.txnHeaderSearch.xenditBalanceAmount ? this.txnHeaderSearch.xenditBalanceAmount : null,
            XenditBalance: this.txnHeaderSearch.xenditBalance ? this.txnHeaderSearch.xenditBalance : null,
            XenditFeeAmount: this.txnHeaderSearch.xenditFeeAmount ? this.txnHeaderSearch.xenditFeeAmount : null,
            XenditFee: this.txnHeaderSearch.xenditFee ? this.txnHeaderSearch.xenditFee : null,
            XenditVatAmount: this.txnHeaderSearch.xenditVatAmount ? this.txnHeaderSearch.xenditVatAmount : null,
            XenditVat: this.txnHeaderSearch.xenditVat ? this.txnHeaderSearch.xenditVat : null,
            DebitAmount: this.txnHeaderSearch.debitAmount ? this.txnHeaderSearch.debitAmount : null,
            Debit: this.txnHeaderSearch.debit ? this.txnHeaderSearch.debit : null,
            CreditAmount: this.txnHeaderSearch.creditAmount ? this.txnHeaderSearch.creditAmount : null,
            Credit: this.txnHeaderSearch.credit ? this.txnHeaderSearch.credit : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ClientLocationType: this.appDataService.getClientLocationType(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.loading = true;
        this.paymentTransactionService.getInOutTransactions(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = dto.Skip;
                this.totalRecords = data.TotalRecords;
                this.paginator.Items = [];
                this.paginator.Items.push(...data.Transactions);
                this.payoutTransactions = data.Transactions.map((x: any) => {
                    x.DisplayFormatCreatedAt = moment(x.CreatedAt).format('DD MMM YYYY | hh:mmA');
                    return x;
                });
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    onSelectionChange(event: any) {
        this.selectedTransaction = event?.data;
    }

    handleHideTransactionInfo() {
        this.showDetailTransactionSidebar = false;
    }

    callGridTitles(skip: number) {
        this.callPayoutTransactions(skip);
    }

    callPayoutTransactions(skip: number) {
        this.getInOutTransactions(skip);
    }

    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1000);
    }

    onDownloadClick(): void {
        const dto = {
            SearchName: this.filter.searchName,
            Id: this.txnHeaderSearch.id ? this.txnHeaderSearch.id : null,
            CreatedAt: this.txnHeaderSearch.createdAt ? moment(this.txnHeaderSearch.createdAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            DisplayFormatCreatedAt: this.txnHeaderSearch.DisplayFormatCreatedAt ? this.txnHeaderSearch.DisplayFormatCreatedAt : null,
            CustomerName: this.txnHeaderSearch.customerName ? this.txnHeaderSearch.customerName : null,
            TransactionType: this.txnHeaderSearch.transactionType ? this.txnHeaderSearch.transactionType : null,
            AmountText: this.txnHeaderSearch.amountText ? this.txnHeaderSearch.amountText : null,
            Status: this.txnHeaderSearch.status ? this.txnHeaderSearch.status : null,
            XenditFee: this.txnHeaderSearch.xenditFee ? this.txnHeaderSearch.xenditFee : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            HeaderColumns: this.exportHeaderColumns,
            DataColumns: this.exportDataColumns
        };
        this.loading = true;
        this.paymentTransactionService.downloadInOutTransactions(dto, this.messageService)
            .then(data => {
                this.loading = false;
                Utils.saveFileResponse(data, 'Xendit-Transactions-' + new Date().valueOf() + '.xlsx');
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
}

class Paginator {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
}
